module.exports = __webpack_public_path__ + "static/media/phil-walker.d911c3d8.jpg";